var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "products-badge", style: _vm.styles }, [
    _c("span", { staticClass: "products-badge__text" }, [
      _vm._v(_vm._s(_vm.badgeText)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }